import React, { Component } from "react";
import PropTypes from "prop-types";
import "./CircleIcon.css";
import settingsIcon from "../settings-icon.svg";
import makersIcon from "../makers-icon.svg";
import contactIcon from "../contact-icon.svg";
import twitterIcon from "../twitter-icon.svg";
import mediumIcon from "../medium-icon.svg";
import creditCardIcon from "../credit-card-icon.svg";
import logoutIcon from "../logout-icon.svg";
import "../../node_modules/font-awesome/css/font-awesome.min.css";

class CircleIcon extends Component {
  getIcon = type => {
    switch (type) {
      case "settings":
        return settingsIcon;
      case "makers":
        return makersIcon;
      case "contact":
        return contactIcon;
      case "twitter":
        return twitterIcon;
      case "medium":
        return mediumIcon;
      case "credit":
        return creditCardIcon;
      case "log-out":
        return logoutIcon;
      default:
        return null;
    }
  };

  render() {
    return (
      <div className={`circle-icon circle-icon-${this.props.type}`}>
        <img
          src={this.getIcon(this.props.type)}
          alt={`${this.props.type}-icon`}
          className="svg"
        />
      </div>
    );
  }
}

CircleIcon.PropTypes = {
  type: PropTypes.string.isRequired
};

export default CircleIcon;



// WEBPACK FOOTER //
// ./src/components/CircleIcon.js